import { render, staticRenderFns } from "./auxiliaryRound.vue?vue&type=template&id=1b1f3da4&scoped=true"
import script from "./auxiliaryRound.vue?vue&type=script&lang=js"
export * from "./auxiliaryRound.vue?vue&type=script&lang=js"
import style0 from "./auxiliaryRound.vue?vue&type=style&index=0&id=1b1f3da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1f3da4",
  null
  
)

export default component.exports